import { createUseStyles } from 'react-jss'
import { colors } from '../../../theme/palette'

type RuleNames = 'circle' | 'text' | 'image' | 'iconContainer'
type RuleNamesCirleIcon = 'iconContainer'

interface StyleProps {
    mWidth?: string
    customRight?: string
    fontSize?: string
    iconWidth?: string
    backgroundColor?: string
    borderColor?: string
    borderWidth?: string
}

interface CirleIconStylesProps {
    width: string
    backgroundColor?: string
    withBorder?: boolean
    borderWidth: string
}

export const cirleIconStyles = createUseStyles<
    RuleNamesCirleIcon,
    CirleIconStylesProps,
    Jss.Theme
>({
    iconContainer: {
        position: 'relative',
        width: ({ width }) => width,
        height: ({ width }) => width,
        backgroundColor: ({ backgroundColor }) => {
            return backgroundColor || colors.blue300
        },
        border: ({ borderWidth, withBorder }) => {
            return withBorder ? `${borderWidth} solid ${colors.white}` : 'none'
        },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        overflow: 'hidden',
        aspectRatio: '1/1',
    },
})

export const styles = createUseStyles<RuleNames, StyleProps, Jss.Theme>({
    circle: {
        position: 'relative',
        width: '100%',
        borderRadius: '50%',
        overflow: 'hidden',
        aspectRatio: '1/1',
        flexShrink: 0,
        marginRight: ({ customRight }) => {
            return customRight || '1rem'
        },
        maxWidth: ({ mWidth }) => mWidth || '2.75rem',
    },
    text: {
        backgroundColor: colors.blue300,
        height: '100%',
        width: '100%',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: ({ fontSize }) => fontSize || '1.125rem',
        color: colors.green500,
        fontWeight: 700,
    },
    image: {
        backgroundColor: colors.black,
        height: '100%',
        width: '100%',
        '& img': {
            objectFit: 'cover',
            width: '100%',
        },
    },
    iconContainer: {
        borderRadius: '50%',
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: colors.green500,
        border: `3px solid ${colors.white}`,
        backgroundColor: ({ backgroundColor }) => {
            return backgroundColor || colors.blue300
        },
        borderColor: ({ borderColor }) => {
            return borderColor || colors.white
        },
        borderWidth: ({ borderWidth }) => {
            return borderWidth || '3px'
        },

        '& > svg': {
            width: ({ iconWidth }) => iconWidth || '70%',
        },
    },
})
